<template>
<v-container fill-height fluid>
  <v-card
    class="mx-auto"
    max-width="900">
    <h2 class="text-center ma-3 mb-n2">Available Short-Term Programs/Qualification Scholarships</h2>
    <v-card-text>
        <v-data-table
          :headers="headers"
          :items="items"
          :items-per-page="100"
          :disable-pagination="true"
          :hide-default-footer="true"
        >
        </v-data-table>
    </v-card-text>
  </v-card>

</v-container>
</template>

<script>

export default {
  name: 'ScholarshipsPage',
  mounted() {
    location.href = 'https://www.korphildavao.site/recent-twsp-scholarship-slots-for-rtc-korphil-with-notice-to-proceed/';
  },
  data() {
    return {
        headers: [
          {
            text: 'No.',
            align: 'start',
            sortable: false,
            value: 'id',
          },
          { text: 'Title', value: 'title' },
          { text: 'Trainer', value: 'trainer' },
          { text: 'Type', value: 'type' },
          { text: 'Duration', value: 'duration' },
          { text: 'Slots', value: 'slots' },
        ],
      items: [
        { id: 1, title: 'Visual Graphic Design NC III', trainer: 'Mario dela Cerna', type: 'TWSP', duration: '63 Days', slots: 20 },
        { id: 2, title: 'Computer Systems Services NC II', trainer: 'Jonathan Lopez', type: 'TWSP', duration: '35 Days', slots: 20 },
        { id: 3, title: 'Machining I', trainer: 'Gil Gonzales', type: 'TWSP', duration: '47 Days', slots: 20 },
        { id: 4, title: 'Mechatronics NC II', trainer: 'Rhian Dhae Sarsaba', type: 'UAQTEA', duration: '27 Days', slots: 25 },
        { id: 5, title: 'Mechatronics NC II', trainer: 'Rhian Dhae Sarsaba', type: 'TWSP', duration: '20 Days', slots: 20 },
        { id: 6, title: 'PV Installation NC II', trainer: 'Jun Sator Layar', type: 'TWSP', duration: '36 Days', slots: 25 },
        { id: 7, title: 'EIM NC II', trainer: 'Maribel Tero', type: 'TWSP', duration: '25 Days', slots: 20 },
        { id: 8, title: 'Carpentry NC II', trainer: 'Joel Magallanes', type: 'TWSP', duration: '38 Days', slots: 20 },
        { id: 9, title: 'Carpentry NC II', trainer: 'Sammy Laviña', type: 'UAQTEA', duration: '55 Days', slots: 25 },
        { id: 10, title: 'Masonry NC II', trainer: 'Alexander Dagohoy', type: 'TWSP', duration: '33 Days', slots: 20 },
        { id: 11, title: 'Plumbing NC II', trainer: 'Edison Tasic', type: 'TWSP', duration: '26 Days', slots: 20 },
        { id: 12, title: 'Food Processing NC II', trainer: 'Mary Joy Alba', type: 'TWSP', duration: '69 Days', slots: 20 },
        { id: 13, title: 'Cookery NC II', trainer: 'Ryan Jandog', type: 'TWSP', duration: '40 Days', slots: 20 },
        { id: 14, title: 'BPP NC II', trainer: 'Marilou Coloma', type: 'TWSP', duration: '18 Days', slots: 20 },
        { id: 15, title: 'SMAW NC II', trainer: 'Engr. Efren Ojeda', type: 'UAQTEA', duration: '45 Days', slots: 25 },
        { id: 16, title: 'SMAW NC I', trainer: 'Joseph Junio', type: 'TWSP', duration: '34 Days', slots: 20 },
        { id: 17, title: 'SMAW NC II', trainer: 'Pladie Solomon', type: 'TWSP', duration: '34 Days', slots: 20 },
        { id: 18, title: 'GMAW NC II', trainer: 'Michael Layar', type: 'UAQTEA', duration: '45 Days', slots: 25 },
        { id: 19, title: 'Rice Machinery Operations NC II', trainer: '(TBA)', type: 'UAQTEA', duration: '39 Days', slots: 25 },
        { id: 20, title: 'Rice Machinery Operations NC II', trainer: 'Engr. Jeric Bilita', type: 'TWSP', duration: '29 Days', slots: 20 },
        { id: 21, title: 'HEO (Forklift) NC II', trainer: '(TBA)', type: 'UAQTEA', duration: '26 Days', slots: 25 },
        { id: 22, title: 'HEO (Forklift) NC II', trainer: 'Engr. Ricky Dabalos', type: 'TWSP', duration: '20 Days', slots: 20 },
        { id: 23, title: 'Motorcycle/Small Engine Servicing NC II', trainer: 'Engr. Ricky Dabalos', type: 'TWSP', duration: '82 Days', slots: 20 },
        { id: 24, title: 'Driving NC II', trainer: 'Armando Bolivar', type: 'TWSP', duration: '15 Days', slots: 20 },
        { id: 25, title: 'Driving (Passenger Bus/Straight Truck NC III)', trainer: 'Armando Bolivar', type: 'TWSP', duration: '16 Days', slots: 20 },
        { id: 26, title: 'Automotive Servicing NC I', trainer: 'Armando Bolivar', type: 'TWSP', duration: '59 Days', slots: 20 },
        { id: 27, title: 'Automotive Servicing NC II', trainer: 'Armando Bolivar', type: 'TWSP', duration: '85 Days', slots: 20 },
        { id: 28, title: 'RAC Servicing (PACU/CRE) NC III', trainer: 'Eugene Valdez', type: 'SUP', duration: '29 Days', slots: 20 },
      ]
    }
  }
}
</script>